var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-report-types" }, [
    _c("h2", { staticClass: "viq-report-types__title" }, [
      _vm._v("Choose a Report Type"),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "viq-report-types__subtitle" }, [
      _vm._v(
        "\n    Select a report format to generate AI-powered regulatory intelligence reports.\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-report-types__grid" },
      _vm._l(_vm.reportTypes, function (rt) {
        return _c(
          "div",
          {
            key: rt.id,
            staticClass: "viq-report-types__card",
            on: {
              click: function ($event) {
                return _vm.selectType(rt.id)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "viq-report-types__card-icon",
                style: { background: rt.bgColor },
              },
              [_c("span", [_vm._v(_vm._s(rt.emoji))])]
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "viq-report-types__card-title" }, [
              _vm._v(_vm._s(rt.title)),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "viq-report-types__card-desc" }, [
              _vm._v(_vm._s(rt.description)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }